/* Înscriere Black Friday Naturvia → Klaviyo Client API (cheie publică, fără cheie privată în temă).
 * Toți înscrișii trimit evenimentul „Inscriere Black Friday 2026” (profil identificat prin email și/sau
 * telefon); cine dă email e abonat și la lista de BF. Telefonul NU se abonează la SMS în Klaviyo:
 * SMS-urile pleacă prin Vodafone, din exportul segmentului. Rulează și în Node, pentru teste. */
(function (root) {
  'use strict';
  var API = 'https://a.klaviyo.com/client/';

  function normalizePhoneRO(input) {
    var d = String(input || '').replace(/[^\d+]/g, '');
    if (d.indexOf('+') === 0) d = d.slice(1);
    else if (d.indexOf('00') === 0) d = d.slice(2);
    if (/^400\d{9}$/.test(d)) d = d.slice(3); // „+40 0722…” / „+40 (0) 722…”
    if (d.indexOf('40') === 0 && d.length === 11) d = d.slice(2);
    if (d.indexOf('0') === 0 && d.length === 10) d = d.slice(1);
    return /^7\d{8}$/.test(d) ? '+40' + d : null;
  }

  function isEmail(s) {
    return /^[^\s@,;]+@[^\s@,;]+\.[^\s@,;.]{2,}$/.test(String(s || '').trim());
  }

  function buildRequests(o) {
    var who = {};
    if (o.email) who.email = o.email;
    if (o.phone) who.phone_number = o.phone;
    var q = '?company_id=' + encodeURIComponent(o.companyId);
    var reqs = [{
      url: API + 'events/' + q,
      body: { data: { type: 'event', attributes: {
        properties: { sursa: o.source, are_email: !!o.email, are_telefon: !!o.phone },
        metric: { data: { type: 'metric', attributes: { name: 'Inscriere Black Friday 2026' } } },
        profile: { data: { type: 'profile', attributes: who } }
      } } }
    }];
    if (o.email) {
      reqs.push({
        url: API + 'subscriptions/' + q,
        body: { data: { type: 'subscription',
          attributes: {
            custom_source: 'Black Friday 2026 - ' + o.source,
            profile: { data: { type: 'profile', attributes: {
              email: o.email,
              subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
            } } }
          },
          relationships: { list: { data: { type: 'list', id: o.listId } } }
        } }
      });
    }
    return reqs;
  }

  // reason: 'invalid' = Klaviyo a respins datele (4xx în afară de 429) → omul trebuie să le corecteze;
  // 'http' = eroare de server/limită (429, 5xx) și 'network' = rețea/timeout → are sens să reîncerce.
  function submitSignup(o, fetchImpl) {
    var f = fetchImpl || root.fetch.bind(root);
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, o.timeoutMs || 15000) : null;
    return Promise.all(buildRequests(o).map(function (r) {
      return f(r.url, {
        method: 'POST',
        credentials: 'omit',
        signal: ctrl ? ctrl.signal : undefined,
        headers: { 'content-type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: o.revision },
        body: JSON.stringify(r.body)
      }).then(function (res) { return res.status; });
    })).then(
      function (codes) {
        clearTimeout(timer);
        if (codes.every(function (c) { return c >= 200 && c < 300; })) return { ok: true };
        var invalid = codes.some(function (c) { return c >= 400 && c < 500 && c !== 429; });
        return { ok: false, reason: invalid ? 'invalid' : 'http' };
      },
      function () { clearTimeout(timer); return { ok: false, reason: 'network' }; }
    );
  }

  // Leagă fiecare <form data-nv-bf-form> din `scope`. Textele vin din data-* (setările secțiunii),
  // iar data-nv-bound împiedică dubla legare când editorul re-randează secțiunea.
  function bindForms(scope) {
    var forms = (scope || root.document).querySelectorAll('form[data-nv-bf-form]');
    Array.prototype.forEach.call(forms, function (form) {
      if (form.getAttribute('data-nv-bound')) return;
      form.setAttribute('data-nv-bound', '1');
      var d = form.dataset, msg = form.querySelector('[role=status]'), btn = form.querySelector('button[type=submit]'), busy = false;
      var trap = form.querySelector('[data-nv-trap]');
      btn.disabled = false; // butonul vine dezactivat din Liquid, ca formularul să nu plece înainte de JS
      function say(t) { msg.textContent = t || ''; }
      function done() {
        form.hidden = true;
        var ok = root.document.getElementById(d.ok);
        if (ok) { ok.hidden = false; if (ok.focus) ok.focus(); }
      }
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy) return;
        var email = form.elements.email.value.trim();
        var rawPhone = form.elements.phone.value.trim();
        var phone = rawPhone ? normalizePhoneRO(rawPhone) : '';
        if (trap && trap.value) { done(); return; }
        if (!email && !rawPhone) return say(d.errEmpty);
        if (email && !isEmail(email)) return say(d.errEmail);
        if (rawPhone && !phone) return say(d.errPhone);
        if (!form.elements.consent.checked) return say(d.errConsent);
        busy = true; btn.disabled = true; say(d.sending);
        submitSignup({ email: email, phone: phone, companyId: d.company, listId: d.list, revision: d.revision, source: d.source })
          .then(function (r) {
            if (r.ok) { say(''); done(); return; }
            busy = false; btn.disabled = false; say(r.reason === 'invalid' ? (d.errInvalid || d.errSend) : d.errSend);
          });
      });
    });
  }

  var api = { normalizePhoneRO: normalizePhoneRO, isEmail: isEmail, buildRequests: buildRequests, submitSignup: submitSignup, bindForms: bindForms };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.NvBfSignup = api;

  if (root.document) {
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', function () { bindForms(); });
    else bindForms();
    root.document.addEventListener('shopify:section:load', function (e) { bindForms(e.target); });
  }
})(typeof window !== 'undefined' ? window : globalThis);
